(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/form/assets/javascripts/form.js') >= 0) return;  svs.modules.push('/modules/form/assets/javascripts/form.js');
"use strict";


const formComponent = new svs.components.form.Form(null, '/');
const addFormIdParams = () => {
  const newUrl = "".concat(window.location.href, "?showForm=").concat(svs.form.data.formId);
  return window.history.replaceState({
    path: newUrl
  }, '', newUrl);
};
const renderForm = () => {
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL) || svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) || svs.core.userSession.hasRole(svs.core.userSession.roles.RETAILER)) {
    formComponent.fetchData(svs.form.data.formId, err => {
      if (!err) {
        formComponent.render();
      }
    });
  } else {
    addFormIdParams(); 
    svs.components.customer_login.login();
  }
};
renderForm();

 })(window);